// Yeni Çek Defteri penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.addCheckBook';

export const addCheckBookGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Çek defteri nasıl tanımlanır?'),
  intro: t(`${G}.intro`, 'Bankadan aldığınız çek defterini sisteme tanıtırsınız; verilen çek yazarken defter ve sıradaki çek numarası buradan gelir. Bu pencere kasa, banka veya cari bakiyesini değiştirmez. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Yeni Çek Defteri'),
    body: t(`${G}.regions.body`, 'Defter bilgileri'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Banka hesabını seçin'),
      text: t(`${G}.s1.text`, 'Banka Hesabı listesinde yalnız "Çek Hesabı" olarak işaretlenmiş banka hesapları ve alt hesaplar görünür. Hesap seçilince Para Birimi hesaptan gelir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Hiç çek hesabı yoksa uyarı çıkar ve Kaydet kapalı kalır. Önce banka hesabını veya alt hesabını "Çek Hesabı" olarak işaretleyin.'),
        t(`${G}.s1.tip2`, 'Düzenlemede banka hesabı ve para birimi değiştirilemez.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Seri numarasını yazın'),
      text: t(`${G}.s2.text`, 'Defterin üzerindeki seri numarasını yazın (ör. ABC123); harfler otomatik büyük harfe çevrilir. Aynı seri numarası ikinci bir defterde kullanılamaz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Numara aralığını girin'),
      text: t(`${G}.s3.text`, 'Başlangıç Numarası defterdeki ilk çekin, Bitiş Numarası son çekin numarasıdır. Başlangıç, bitişten küçük olmalıdır. Yaprak sayısı (Bitiş − Başlangıç + 1) altta bilgi kutusunda görünür.'),
      tips: [
        t(`${G}.s3.tip1`, 'Verilen çek yazarken çek numarası bu aralık dışında olamaz.'),
        t(`${G}.s3.tip2`, 'Defterden yaprak kullanıldıktan sonra numara aralığı değiştirilemez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kaydedin'),
      text: t(`${G}.s4.text`, 'Açıklama isteğe bağlıdır. "Kaydet" (düzenlemede "Güncelle") defteri kaydeder; başarı mesajından kısa süre sonra pencere kapanır. Yeni defter aktif olarak başlar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Düzenlemede Aktif anahtarı görünür. Pasif defter, çek yazarken Çek Defteri listesinde çıkmaz.'),
      ],
    },
  ],
});
